import DynamicVideo from "components/DynamicVideo"

export default function InlineVideo({ blok }) {
  return <DynamicVideo {...blok.video[0]} />
}
